import * as React from "react";
import './screen-loader.scss';

export const ScreenLoader = ({numOfCircles = 12, loaderColor = "#445870"}) => {

    (numOfCircles > 8 && numOfCircles <= 13) ? numOfCircles = numOfCircles : numOfCircles = 12;

    const midpoint = numOfCircles/2 +.5;
    const farthestDistancePossible = midpoint-1;

    const styles = (idx = null) => ({
        rotatingCircleLoader: {
        width: 100,
        height: 100,
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "--my-var": numOfCircles,
        "--var-color": loaderColor,
        },
        circleContainer: {
        width: "100%",
        height: "25%",
        position: "absolute",
        transform: 'rotate('+ (360/numOfCircles) * idx +'deg)'
        },
        circlePadding: {
        width: "75%",
        height: "100%",
        position: "absolute",
        opacity: 0,
        },
        circle: {
        width: "25%",
        height: "100%",
        position: "absolute",
        borderRadius: "50%",
        transform: 'scale(' + 0.8 * (farthestDistancePossible - (Math.abs( idx + 1 - midpoint )) ) / Math.trunc(farthestDistancePossible) + ')',
        backgroundColor: loaderColor,
        }
    });

    return(
        <div
        className="rotatingCircleLoader"
        style={styles().rotatingCircleLoader}
        >
        {[...Array(numOfCircles)].map((_, idx) =>
            <div className="circleContainer"
            id={"spokeMain-"+idx}
            style={styles(idx).circleContainer}
            key={"loader-spoke-div-"+idx}
            >
            <div
                id={"spoke-"+idx+"-TransparentBase"}
                style={styles().circlePadding}
            />
            <div
                id={"spoke-"+idx+"-Shown"}
                style={styles(idx).circle}
            />
            </div>
        )}
        </div>
    );
}